<template>
  <div></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { BoxBufferGeometry, MeshBasicMaterial, Mesh, DoubleSide, Color } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      let geo = new BoxBufferGeometry(5000, 5000, 5000, 30, 30, 30)
      let mat = new MeshBasicMaterial({ side: DoubleSide, color: new Color('#bababa') })
      let mesh = new Mesh(geo, mat)

      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>